import React from 'react';
import '../../styles/layout/landing.scss';

const LandingPageText = () => {
  return (
    <div className='bottom-text'>
      <h4>
        {' '}
        The Case for Quality Voluntary Improvement Program (VIP) is a collaborative initiative
        between FDA, CDRH, MDIC, ISACA, and the medical device industry.
      </h4>
      <h4>
        {' '}
        This Program was developed to advance the standards of medical device quality and safety
        through sustained and predictive practices that achieve better patient outcomes.
      </h4>
      <h4>
        {' '}
        The VIP Portal enables program collaborators to access various data reports to see industry
        trends and understand the impact to organizational performance.
      </h4>
    </div>
  );
};

export default LandingPageText;
